export default {"src":"/_next/static/media/listmarkIcon.fa092fdf.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};